"use client";

import { c as _c } from "react/compiler-runtime";
import { ChevronRight, type LucideIcon } from "lucide-react";
import { Collapsible, CollapsibleContent, CollapsibleTrigger } from "@/components/ui/collapsible";
import { SidebarGroup, SidebarGroupLabel, SidebarMenu, SidebarMenuAction, SidebarMenuButton, SidebarMenuItem, SidebarMenuSub, SidebarMenuSubButton, SidebarMenuSubItem } from "@/components/ui/sidebar";
import Link from "next/link";
import { usePathname } from "next/navigation";
interface SidebarMenuItemProps {
  title: string;
  url: string;
  icon: LucideIcon;
  activeIcon?: LucideIcon;
  isActive?: boolean;
  isExternal?: boolean;
  items?: SidebarMenuItemProps[];
}
export function NavMain(t0) {
  const $ = _c(14);
  const {
    items,
    groupLabel: t1
  } = t0;
  const groupLabel = t1 === undefined ? "Navigate" : t1;
  const pathname = usePathname();
  let t2;
  if ($[0] !== pathname) {
    t2 = item => {
      if (item.isActive) {
        return true;
      }
      if (item.url === "/dashboard") {
        return pathname === "/dashboard";
      }
      if (item.url.startsWith("/dashboard/projects/")) {
        return pathname === item.url || pathname.startsWith(`${item.url}/`);
      }
      return pathname.startsWith(item.url);
    };
    $[0] = pathname;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const isItemActive = t2;
  let t3;
  if ($[2] !== groupLabel) {
    t3 = <SidebarGroupLabel>{groupLabel}</SidebarGroupLabel>;
    $[2] = groupLabel;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== isItemActive || $[5] !== items) {
    let t5;
    if ($[7] !== isItemActive) {
      t5 = item_0 => {
        const active = isItemActive(item_0);
        return <Collapsible key={item_0.title} asChild={true} defaultOpen={item_0.isActive}><SidebarMenuItem><SidebarMenuButton asChild={true} tooltip={item_0.title} isActive={active}>{item_0.isExternal ? <a href={item_0.url} target="_blank" rel="noopener noreferrer">{item_0.activeIcon && active ? <item_0.activeIcon /> : <item_0.icon />}<span>{item_0.title}</span></a> : <Link href={item_0.url}>{item_0.activeIcon && active ? <item_0.activeIcon /> : <item_0.icon />}<span>{item_0.title}</span></Link>}</SidebarMenuButton>{item_0.items?.length ? <><CollapsibleTrigger asChild={true}><SidebarMenuAction className="data-[state=open]:rotate-90"><ChevronRight /><span className="sr-only">Toggle</span></SidebarMenuAction></CollapsibleTrigger><CollapsibleContent><SidebarMenuSub>{item_0.items?.map(_temp)}</SidebarMenuSub></CollapsibleContent></> : null}</SidebarMenuItem></Collapsible>;
      };
      $[7] = isItemActive;
      $[8] = t5;
    } else {
      t5 = $[8];
    }
    t4 = items.map(t5);
    $[4] = isItemActive;
    $[5] = items;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[9] !== t4) {
    t5 = <SidebarMenu>{t4}</SidebarMenu>;
    $[9] = t4;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t3 || $[12] !== t5) {
    t6 = <SidebarGroup className="py-0">{t3}{t5}</SidebarGroup>;
    $[11] = t3;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  return t6;
}
function _temp(subItem) {
  return <SidebarMenuSubItem key={subItem.title}><SidebarMenuSubButton asChild={true}>{subItem.isExternal ? <a href={subItem.url} target="_blank" rel="noopener noreferrer"><subItem.icon /><span>{subItem.title}</span></a> : <Link href={subItem.url}><subItem.icon /><span>{subItem.title}</span></Link>}</SidebarMenuSubButton></SidebarMenuSubItem>;
}